import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import NotReviewed from './/NotReviewed'
import { trans } from '../../../../_providers/Translation'
import { useNewReservationsContext } from '../../../../_providers/NewReservations'

//style
import '@/assets/scss/pages/dashboard.scss'

//images
import bellImage from '@/assets/img/reservations/bell.png'
import Api from '../../../../_helpers/Api'
// import Skeleton from 'react-loading-skeleton'
import moment from 'moment'
import { Skeleton } from '@mui/material'

function Reservation(props) {

    const [state, setState] = useState({
        loading: true,
        latest: {},
        data: [],
        total: 0
    })

    const modalNotReviewed = useRef(null)
    const newReservations = useNewReservationsContext()

    useEffect(() => {
        Api.get(`reservations/not-reviewed`)
            .then(res => {
                const data = res.data.data || []
                setState(prev => ({
                    ...prev,
                    data: data,
                    latest: data[0] || {},
                    total: res.data.total,
                    loading: false
                }))
            })
    }, [])

    const handleView = () => {
        modalNotReviewed.current.show()
    }

    const handleActionComplete = () => {
        // Refresh the data when accept/reject actions are completed
        setState(prev => ({ ...prev, loading: true }))
        Api.get(`reservations/not-reviewed`)
            .then(res => {
                const data = res.data.data || []
                setState(prev => ({
                    ...prev,
                    data: data,
                    latest: data[0] || {},
                    total: res.data.total,
                    loading: false
                }))

                // Refresh the global count
                if (newReservations) {
                    newReservations.refresh()
                }
            })
    }

    const handleReservationUpdate = () => {
        // This callback can be used by parent components to refresh main reservations table
        if (props.onReservationUpdate) {
            props.onReservationUpdate()
        }

        // Also refresh the not-reviewed list
        handleActionComplete()
    }

    return (
        <>
            <NotReviewed
                ref={modalNotReviewed}
                data={state.data}
                onActionComplete={handleActionComplete}
                onReservationUpdate={handleReservationUpdate}
            />
            {state.loading
                ?
                <Skeleton height={200} style={{
                    transform: "scale(1)"
                }} />
                :
                state.total === 0 ? <></> :
                    <>
                        <div className="reservation-panel" style={props.style || {}} onClick={handleView}>
                            <div className='top'>
                                <div className='left'>
                                    <div className='title'>
                                        <div className='bell-icon'>
                                            <img src={bellImage} alt="bell" />
                                            <span>
                                                {state.total}
                                            </span>
                                        </div>
                                        <div className='main-content'>
                                            <b>
                                                {moment(state.latest.created_at).format('DD MMM YYYY / HH:mm')}
                                            </b>
                                            <h4>
                                                {trans('random.newReservation')}
                                            </h4>
                                            <span>
                                                {state.latest.color_desc}
                                            </span>
                                        </div>
                                    </div>
                                    <div className='details'>
                                        <div className='detail-item'>
                                            <span>{trans('random.client')}</span>
                                            {state.latest.customer.name}
                                        </div>
                                        <div className='detail-item'>
                                            <span>Дата и час</span>
                                            {moment(state.latest.visit_date).format('DD MMM YYYY / HH:mm')}
                                        </div>
                                        <div className='detail-item'>
                                            <span>{trans('random.address')}</span>
                                            {state.latest.address}
                                        </div>
                                    </div>
                                </div>
                                <button className='button button-primary'>
                                    {trans('buttons.viewDetails')}
                                </button>
                            </div>
                            <div className='bottom'>
                                <div className='details'>
                                    <div className='detail-item'>
                                        <span>{trans('random.problem')}</span>
                                        {state.latest.description || "Не е посочен"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>

    )
}

export default Reservation